<template>
    <div class="card has-text-centered">
      <div class="card-content widget-profile widget-primary">
        <h2>{{name}}</h2>
        <h3>{{profileFunction}}</h3>

        <img src="http://via.placeholder.com/100x100" :alt="name" :title="name">

        <div class="misc">
          {{tweets}} Tweets | {{following}} Following | {{followers}} Followers
        </div>
      </div>
      <div class="card-footer">
        <div class="card-footer-item">
          <a :href="facebookLink"><i class="fab fa-facebook-f"></i></a>
        </div>
        <div class="card-footer-item">
          <a :href="twitterLink"><i class="fab fa-twitter"></i></a>
        </div>
      </div>
    </div>

</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: 'John Doe',
    },
    profileFunction: {
      type: String,
      default: 'WEBDEVELOPER at UPDIVISION',
    },
    tweets: {
      type: Number,
      default: 100,
    },
    following: {
      type: Number,
      default: 500,
    },
    followers: {
      type: Number,
      default: 140,
    },
    facebookLink: {
      type: String,
      default: '#',
    },
    twitterLink: {
      type: String,
      default: '#',
    },
  },
};
</script>


<style scoped>
  .card {
    margin-bottom: 0;
  }
  .widget-profile h2 {
    font-size: 1.75rem;
    font-weight: bold;
  }

  .widget-profile h3 {
    font-size: 0.75rem;
    font-weight: normal;
  }

  .widget-profile img {
    border-radius: 50%;
    border: 5px SOLID #FFF;
    margin: 15px 0;
  }

  .widget-primary {
    background-color: #1ab394;
    color: #ffffff;
  }
</style>
